import React, { useState, useEffect } from 'react';
import { Box, Modal } from '@material-ui/core';
import chessslogo from '../../images/chessslogo.png';
import { useHistory } from 'react-router-dom';
import FAQAndSettingsModal from './FAQAndSettingsModal';
import goldCrown from '../../images/CrownGold.png';
import axios from 'axios';
import { connect } from 'react-redux';
import { getUserData } from '../../redux/actions/userActions';
import ProfilePictureUpload from '../profile/ProfilePictureUpload';

const WelcomeLoginModal = ({ onClose, user, getUserData }) => {
  const [modalOpen, setModalOpen] = useState(true);
  const [showFAQModal, setShowFAQModal] = useState(false);
  const [popupStage, setPopupStage] = useState(1);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  // Add state for unsaved changes tracking and confirmation modal
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  // Add state for success popup
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  // Add error state for social media links
  const [error, setError] = useState({
    youtube: "",
    tiktok: "",
    instagram: "",
    twitter: ""
  });

  // Add state for social media links with proper format hints
  const [links, setLinks] = useState({
    youtube: { name: 'www.youtube.com/username', icon: 'fa-youtube', value: user?.credentials?.youtubeLink || "" },
    tiktok: { name: 'www.tiktok.com/username', icon: 'fa-tiktok', value: user?.credentials?.tiktokLink || "" },
    instagram: { name: 'www.instagram.com/username', icon: 'fa-instagram', value: user?.credentials?.instagramLink || "" },
    twitter: { name: 'www.twitter.com/username', icon: 'fa-x-twitter', value: user?.credentials?.twitterLink || "" }
  });

  const history = useHistory();

  // Profile data state for second tab
  const [profile, setProfile] = useState({
    status: user?.credentials?.status || "",
    bio: user?.credentials?.biography || "",
    youtube: user?.credentials?.youtubeLink || "",
    tiktok: user?.credentials?.tiktokLink || "",
    instagram: user?.credentials?.instagramLink || "",
    twitter: user?.credentials?.twitterLink || ""
  });

  // Store original values for comparison
  const [originalValues, setOriginalValues] = useState({
    status: "",
    bio: "",
    youtube: "",
    tiktok: "",
    instagram: "",
    twitter: ""
  });

  // Characters remaining in status
  const [statusChars, setStatusChars] = useState(profile.status ? 15 - profile.status.length : 15);

  // Add state to track which fields are completed
  const [completedFields, setCompletedFields] = useState({
    status: false,
    bio: false,
    youtube: false,
    tiktok: false,
    instagram: false,
    twitter: false
  });

  // In the component function, add state for photo URLs
  const [photoUrl, setPhotoUrl] = useState('');
  const [pendingPhotoUrl, setPendingPhotoUrl] = useState('');

  // Validate social media links, return full link if valid, return an error message if invalid
  const validateLink = (link, platformName) => {
    // Extract just the domain name from the platformName (e.g. "youtube" from "www.youtube.com/username")
    const domainRegex = /www\.([^.]+)\.com\/.*/;
    const match = platformName.match(domainRegex);
    const domain = match ? match[1] : null;

    if (!domain) {
      return "Invalid platform format";
    }

    // Create the proper domain pattern
    const start = "https://";
    const domainSite = "www." + domain + ".com/"; // Valid link must have www.domain.com/

    // Check if the URL already has https:// or http:// prefix - if so, trim it for processing
    let processedLink = link;
    if (link.toLowerCase().startsWith('https://')) {
      processedLink = link.substring(8); // Remove https://
    } else if (link.toLowerCase().startsWith('http://')) {
      processedLink = link.substring(7); // Remove http://
    }

    // If the user entered just a username, add the domain for them
    if (!processedLink.includes(".")) {
      return start + domainSite + processedLink;
    }

    const lower = processedLink.toLowerCase();

    // Check if the domain is in the link
    if (!lower.includes(domain + ".com")) {
      return "Link must include " + domain + ".com";
    }

    // If user entered domain without www, add it
    if (!lower.startsWith("www.")) {
      processedLink = "www." + processedLink;
    }

    // Make sure the format is correct
    if (!lower.startsWith("www." + domain + ".com/") && !lower.startsWith("www." + domain + ".com")) {
      // Try to extract username if domain is present but format is wrong
      const usernameMatch = lower.match(new RegExp(domain + "\\.com\\/?(.*)", "i"));
      if (usernameMatch && usernameMatch[1]) {
        return start + domainSite + usernameMatch[1];
      }
      return start + domainSite + lower.split(domain + ".com").pop();
    }

    // Remove extra '/'
    if (lower.startsWith("www." + domain + ".com/")) {
      const username = processedLink.substring(("www." + domain + ".com/").length);
      return start + domainSite + username;
    } else {
      return start + domainSite;
    }
  };

  // Handle link changes
  const handleLinkChange = (e) => {
    const { name, value } = e.target;

    // Log changes to help with debugging
    

    // Update the links state
    setLinks(prev => ({
      ...prev,
      [name]: { ...prev[name], value }
    }));

    // Set unsaved changes flag to true as soon as user types
    if (!hasUnsavedChanges) {
      
      setHasUnsavedChanges(true);
    }
  };

  // Check the user's popup stage on component mount
  useEffect(() => {
    if (user && user.credentials && user.credentials.Popup) {
      // Set the popup stage based on user data
      const currentStage = parseInt(user.credentials.Popup);
      
      setPopupStage(currentStage);

      // If user has completed onboarding (stage 3), close the modal
      if (currentStage === 3) {
        setModalOpen(false);
        if (onClose) onClose();
      }
    }
  }, [user]);

  // Set original values when user data loads
  useEffect(() => {
    if (user && user.credentials) {
      const newOriginalValues = {
        status: user.credentials.status || "",
        bio: user.credentials.biography || "",
        youtube: user.credentials.youtubeLink || "",
        tiktok: user.credentials.tiktokLink || "",
        instagram: user.credentials.instagramLink || "",
        twitter: user.credentials.twitterLink || ""
      };
      
      setOriginalValues(newOriginalValues);
      
      // Also update profile and links states to match the user data
      setProfile({
        status: newOriginalValues.status,
        bio: newOriginalValues.bio,
        youtube: newOriginalValues.youtube,
        tiktok: newOriginalValues.tiktok,
        instagram: newOriginalValues.instagram,
        twitter: newOriginalValues.twitter
      });
      
      setLinks(prev => ({
        youtube: { ...prev.youtube, value: newOriginalValues.youtube },
        tiktok: { ...prev.tiktok, value: newOriginalValues.tiktok },
        instagram: { ...prev.instagram, value: newOriginalValues.instagram },
        twitter: { ...prev.twitter, value: newOriginalValues.twitter }
      }));
      
      // Reset unsaved changes flag since we're syncing with fresh data
      setHasUnsavedChanges(false);
    }
  }, [user]);

  // Update completedFields when user data loads
  useEffect(() => {
    if (user && user.credentials) {
      const fields = {
        status: Boolean(user.credentials.status || user.credentials.pendingStatus),
        bio: Boolean(user.credentials.biography || user.credentials.pendingBiography),
        youtube: Boolean(user.credentials.youtubeLink || user.credentials.pendingYoutubeLink),
        tiktok: Boolean(user.credentials.tiktokLink || user.credentials.pendingTikTokLink),
        instagram: Boolean(user.credentials.instagramLink || user.credentials.pendingInstagramLink),
        twitter: Boolean(user.credentials.twitterLink || user.credentials.pendingTwitterLink)
      };

      setCompletedFields(fields);

      // If all fields are completed, auto-advance to stage 3
      if (Object.values(fields).every(field => field === true)) {
        const nextStage = 3;
        
        axios.post('/user', { Popup: nextStage })
          .then(() => {
            getUserData();
            setModalOpen(false);
            if (onClose) onClose();
          })
          .catch(error => console.error("Error updating popup stage:", error));
      }
    }
  }, [user]);

  // Check for unsaved changes when profile data changes
  useEffect(() => {
    if (popupStage === 2) { // Only check for changes in profile setup tab
      // Only check for changes if original values have been properly initialized
      // This prevents false positives during component initialization
      const originalValuesInitialized = Object.values(originalValues).some(val => val !== "");
      
      if (!originalValuesInitialized && user && user.credentials) {
        // Original values not set yet, skip this check
        
        return;
      }

      // Compare each field to its original value
      const hasChanges =
        profile.status !== originalValues.status ||
        profile.bio !== originalValues.bio ||
        links.youtube.value !== originalValues.youtube ||
        links.tiktok.value !== originalValues.tiktok ||
        links.instagram.value !== originalValues.instagram ||
        links.twitter.value !== originalValues.twitter;

      
      // console.log("  Current values:", {
      //   status: profile.status,
      //   bio: profile.bio,
      //   youtube: links.youtube.value,
      //   tiktok: links.tiktok.value,
      //   instagram: links.instagram.value,
      //   twitter: links.twitter.value
      // });
      
      

      setHasUnsavedChanges(hasChanges);
    }
  }, [profile, links, originalValues, popupStage, user]);

  // Add custom tab navigation interception
  useEffect(() => {
    // Only active when we're on the profile setup tab and have unsaved changes
    if (popupStage !== 2 || !hasUnsavedChanges) return;

    

    // Function to intercept navigation attempts
    const handleTabNavigation = (event) => {
      const target = event.target;

      // Check if the clicked element is a navigation link or button
      // This covers buttons in the modal that would navigate away
      if (
        target.tagName === 'A' ||
        target.closest('a') ||
        target.tagName === 'BUTTON' ||
        target.closest('button') ||
        // Skip elements that are already handled by our modal's save/discard buttons
        (target.closest('.nav-link') && !target.closest('#confirmModal'))
      ) {
        // Ignore clicks on the Save Changes and Don't Save buttons in our modal
        if (
          target.closest('#saveChangesBtn') ||
          target.closest('#discardChangesBtn') ||
          showConfirmModal // Already showing confirmation
        ) {
          return;
        }

        // Log the intercept
        

        // Prevent the default navigation
        event.preventDefault();
        event.stopPropagation();

        // Store the action to take after confirmation
        setPendingAction(() => () => {
          // If it's an anchor with href, navigate there
          if (target.href) {
            window.location.href = target.href;
          } else if (target.closest('a')?.href) {
            window.location.href = target.closest('a').href;
          } else if (target.onclick || target.closest('button')?.onclick) {
            // If it has a click handler, we'll close the modal and let the handler take over
            setModalOpen(false);
            if (onClose) onClose();
          }
        });

        // Show confirmation modal
        setShowConfirmModal(true);
      }
    };

    // Add click event listener to the modal content
    const modalElement = document.querySelector('.modal-content');
    if (modalElement) {
      modalElement.addEventListener('click', handleTabNavigation, true);
    } else {
      // If we can't find the modal content, listen on the document
      document.addEventListener('click', handleTabNavigation, true);
    }

    // Clean up the event listener
    return () => {
      if (modalElement) {
        modalElement.removeEventListener('click', handleTabNavigation, true);
      } else {
        document.removeEventListener('click', handleTabNavigation, true);
      }
    };
  }, [popupStage, hasUnsavedChanges, showConfirmModal]);

  // Debug effect to monitor unsaved changes
  useEffect(() => {
    
  }, [hasUnsavedChanges]);

  const handleClose = () => {
    
    // Check for unsaved changes if on profile setup tab
    if (popupStage === 2 && hasUnsavedChanges) {
      
      // Store the close action to execute after confirmation
      setPendingAction(() => () => {
        if (dontShowAgain) {
          updatePopupStage();
        }
        setModalOpen(false);
        if (onClose) onClose();
      });

      // Show confirmation modal
      setShowConfirmModal(true);
      return;
    }

    
    // No unsaved changes, proceed with normal close
    if (dontShowAgain) {
      updatePopupStage();
    }

    setModalOpen(false);
    if (onClose) onClose();
  };

  // Update the user's popup stage in the database
  const updatePopupStage = async () => {
    try {
      const nextStage = popupStage + 1;
      

      // Update the Popup field in the user document
      await axios.post('/user', { Popup: nextStage });

      // Refresh user data
      getUserData();
    } catch (error) {
      console.error("Error updating popup stage:", error);
    }
  };

  const handleEditProfile = () => {
    // If we have unsaved changes, show confirmation
    if (popupStage === 2 && hasUnsavedChanges) {
      setPendingAction(() => () => {
        // Open profile with Edit tab in a new tab
        window.open('/profile?tab=Edit', '_blank');
        // Also open premium in another new tab
        window.open('/premium', '_blank');
      });

      setShowConfirmModal(true);
      return;
    }

    // No unsaved changes, proceed normally
    

    // Use a slight delay to ensure the modal is fully closed before navigation
    setTimeout(() => {
      // Open profile with Edit tab in a new tab
      window.open('/profile?tab=Edit', '_blank');
      // Also open premium in another new tab
      window.open('/premium', '_blank');
    }, 100);
  };

  // Handle profile field changes for second tab
  const handleProfileChange = (e) => {
    const { name, value } = e.target;

    // Log changes to help with debugging
    

    // Update the profile state
    setProfile(prev => ({
      ...prev,
      [name]: value
    }));

    // Update character count for status field
    if (name === 'status') {
      setStatusChars(15 - value.length);
    }

    // Set unsaved changes flag to true as soon as user types
    // This ensures the confirmation dialog appears for any edit
    if (!hasUnsavedChanges) {
      
      setHasUnsavedChanges(true);
    }
  };

  // Handle saving changes and force close confirmation modal
  const handleSaveProfile = async () => {
    
    try {
      const dataToUpdate = {};
      let isValid = true;
      let hasChanges = false;

      // Validate and process social media links
      Object.keys(links).forEach((social) => {
        // Link is modified
        if (links[social].value !== originalValues[social]) {
          // If link is blank, accept it without validation
          if (!links[social].value) {
            setError(prev => ({ ...prev, [social]: "" }));
            return;
          }

          // Otherwise validate the link
          const validate = validateLink(links[social].value, links[social].name);

          // Link is invalid
          if (!(validate.startsWith("https://"))) {
            setError(prev => ({ ...prev, [social]: validate }));
            isValid = false;
            return;
          }

          setError(prev => ({ ...prev, [social]: "" })); // Clear error message
          // Add valid link to dataToUpdate as pending
          switch (social) {
            case 'youtube':
              dataToUpdate.pendingYoutubeLink = [validate, false];
              break;
            case 'tiktok':
              dataToUpdate.pendingTikTokLink = [validate, false];
              break;
            case 'instagram':
              dataToUpdate.pendingInstagramLink = [validate, false];
              break;
            case 'twitter':
              dataToUpdate.pendingTwitterLink = [validate, false];
              break;
          }
          hasChanges = true;
        }
      });

      // ALWAYS force close confirmation modal, regardless of validation results
      setShowConfirmModal(false);

      // Stop if links are invalid, but only after closing confirmation modal
      if (!isValid) {
        
        return;
      }

      // Compare each field with its original value
      if (profile.status !== originalValues.status) {
        if (profile.status) {
          dataToUpdate.pendingStatus = [profile.status, false];
          hasChanges = true;
        }
      }

      if (profile.bio !== originalValues.bio) {
        if (profile.bio) {
          dataToUpdate.pendingBiography = [profile.bio, false];
          hasChanges = true;
        }
      }

      // Always include the Popup field update if checkbox is checked
      if (dontShowAgain) {
        const nextStage = popupStage + 1;
        dataToUpdate.Popup = nextStage;
        hasChanges = true;
      }

      // Only make API call if we have actual changes to submit
      if (hasChanges) {
        
        await axios.post('/user', dataToUpdate);
        getUserData();
      }

      // Reset unsaved changes flag
      setHasUnsavedChanges(false);
      

      // Show success popup
      setShowSuccessPopup(true);

      // Only close the main modal if validation was successful
      if (isValid) {
        // Close the main modal after a short delay
        setTimeout(() => {
          setModalOpen(false);
          if (onClose) onClose();
        }, 1500);
      }

      // Hide success popup after 3 seconds
      setTimeout(() => {
        setShowSuccessPopup(false);
      }, 3000);

    } catch (error) {
      console.error("Error updating profile:", error);
      // Keep modal open on error
      setShowConfirmModal(false);
    }
  };

  // Handle discarding changes with force close
  const handleDiscardChanges = () => {
    

    // Always force close the confirmation modal
    setShowConfirmModal(false);

    // Reset the global unsaved changes flag
    setHasUnsavedChanges(false);
    

    // Execute the pending action
    if (pendingAction) {
      
      setTimeout(pendingAction, 100);
      setPendingAction(null);
    }
  };

  // Base styles for all buttons
  const buttonBaseStyle = {
    background: 'rgba(30, 30, 30, 0.8)',
    color: 'white',
    border: '1px solid rgba(255, 215, 0, 0.5)',
    padding: '15px',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '20px',
    fontWeight: 'bold',
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    textTransform: 'uppercase',
  };

  // Styles for different button types
  const buttonStyles = {
    blue: {
      borderLeft: '4px solid rgb(0, 120, 212)',
      background: 'rgba(0, 120, 212, 0.2)',
      color: '#0078d4',
    },
    pink: {
      borderLeft: '4px solid rgb(255, 0, 80)',
      background: 'rgba(255, 0, 80, 0.2)',
      color: '#ff0050',
    },
    gold: {
      borderLeft: '4px solid rgb(255, 215, 0)',
      background: 'rgba(255, 215, 0, 0.2)',
      color: 'gold',
    },
    green: {
      borderLeft: '4px solid rgb(0, 255, 0)',
      background: 'rgba(0, 255, 0, 0.1)',
      color: 'green',
    }
  };

  // Style for input fields
  const inputStyle = {
    width: '95%',
    padding: '12px 15px',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    fontSize: '16px',
    color: 'white',
    border: '2px solid rgba(255, 215, 0, 0.5)',
    borderRadius: '8px',
    outline: 'none',
    marginBottom: '15px',
    transition: 'all 0.3s ease'
  };

  const inputStyle2 = {
    width: '80%',
    padding: '12px 15px',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    fontSize: '16px',
    color: 'white',
    border: '2px solid rgba(255, 215, 0, 0.5)',
    borderRadius: '8px',
    outline: 'none',
    marginBottom: '15px',
    transition: 'all 0.3s ease'
  };

  // Function to render welcome tab (stage 1)
  const renderWelcomeTab = () => (
    <>
      {/* Top section - Welcome header */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '30px 30px 20px',
        borderBottom: '1px solid rgba(255, 215, 0, 0.3)',
        backgroundColor: 'rgba(20, 20, 20, 0.8)',
      }}>
        <img
          src={chessslogo}
          alt="Chess Social Logo"
          style={{
            width: '80px',
            height: '80px',
            marginBottom: '15px'
          }}
        />
        <div style={{
          color: 'gold',
          fontSize: '30px',
          fontWeight: 'bold',
          marginBottom: '5px',
          textTransform: 'uppercase',
          letterSpacing: '2px',
          textAlign: 'center',
          fontFamily: 'mansalva, cursive'
        }}>
          ChessThread.com
        </div>

        <div style={{
          color: '#58b047',
          fontSize: '24px',
          marginBottom: '5px',
          textAlign: 'center',
          fontStyle: 'italic'
        }}>
          Where sharing chess is simple.
        </div>
      </div>

      {/* Bottom section - features and continue button */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '25px 30px 30px',
        backgroundColor: 'rgba(0, 0, 0, 0.9)'
      }}>
        {/* 2x2 Grid for first 4 buttons */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '15px',
          marginBottom: '20px'
        }}>
          {/* FAQ Button */}
          <button
            onClick={() => setShowFAQModal(true)}
            style={{
              ...buttonBaseStyle,
              ...buttonStyles.blue,
            }}
          >
            <i className="fa-solid fa-circle-question" style={{ fontSize: '20px' }}></i> FAQ
          </button>

          {/* Find Creators Button */}
          {/* <button
            onClick={() => window.open('/explore', '_blank')}
            style={{
              ...buttonBaseStyle,
              ...buttonStyles.blue,
            }}
          >
            <i className="fa-solid fa-user-group" style={{ fontSize: '20px' }}></i> Find Creators
          </button> */}

          {/* Customize Profile Button */}
          <button
            onClick={handleEditProfile}
            style={{
              ...buttonBaseStyle,
              ...buttonStyles.blue,
            }}
          >
            <i className="fa-solid fa-chess-king" style={{ fontSize: '20px', paddingBottom: '5px' }}></i> Edit Profile
          </button>

         
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '20px', width: '100%' }}>
           {/* Share Chess Button */}
           <button
            onClick={() => window.open('/analysis', '_blank')}
            style={{
                ...buttonBaseStyle,
              ...buttonStyles.green,
              width: '100%',
              height: '70px',
            }}
          >
            <i className="fa-solid fa-square-plus" style={{ fontSize: '20px' }}></i> Start Creating Chess Content
          </button>
        </div>

        {/* Full-width buttons */}
        {/* <button
          onClick={() => window.open('/premium', '_blank')}
          style={{
            ...buttonBaseStyle,
            ...buttonStyles.gold,
            width: '100%',
            marginBottom: '15px',
            padding: '18px'
          }}
        >
          <img src={goldCrown} alt="Gold Crown" style={{ width: '30px', height: '30px', marginRight: '' }} />
          Level Up With Premium
        </button> */}

        <button
          onClick={handleClose}
          style={{
            ...buttonBaseStyle,
            ...buttonStyles.pink,
            width: '100%',
            padding: '22px',
            marginBottom: '20px'
          }}
        >
          <i className="fa-solid fa-chess" style={{ fontSize: '20px', paddingBottom: '5px' }}></i> Start Exploring
        </button>

        {/* Don't show again checkbox */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: '10px'
        }}>
          <input
            type="checkbox"
            id="dontShowAgain"
            checked={dontShowAgain}
            onChange={(e) => setDontShowAgain(e.target.checked)}
            style={{ marginRight: '10px', transform: 'scale(1.2)' }}
          />
          <label
            htmlFor="dontShowAgain"
            style={{
              color: 'rgba(255, 255, 255, 0.8)',
              fontSize: '16px',
              cursor: 'pointer'
            }}
          >
            Don't Show This Again
          </label>
        </div>
      </div>
    </>
  );

  // Function to render profile setup tab (stage 2)
  const renderProfileSetupTab = () => (
    <>
      {/* Top section - Profile Setup header */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px 30px 15px',
        borderBottom: '1px solid rgba(255, 215, 0, 0.3)',
        backgroundColor: 'rgba(20, 20, 20, 0.8)'
      }}>
        <div style={{
          color: 'gold',
          fontSize: '24px',
          fontWeight: 'bold',
          marginBottom: '5px',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          textAlign: 'center'
        }}>
          Complete Your Profile
        </div>
      </div>



      {/* Profile setup form */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '20px 30px',
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        maxHeight: '88vh',
        overflowY: 'auto'
      }}>
         {/* Only show the profile picture upload if both photoUrl and pendingPhotoUrl are blank */}
         {!photoUrl && !pendingPhotoUrl && (
          <div style={{ marginBottom: '10px' }}>
            
            <ProfilePictureUpload 
              userId={user?.credentials?.userId}
              photoUrl={photoUrl}
              pendingPhotoUrl={pendingPhotoUrl}
              setPhotoUrl={setPhotoUrl}
              setPendingPhotoUrl={setPendingPhotoUrl}
              size="small"
              onUploadComplete={handleProfilePictureUpload}
            />
            
          </div>
        )}
        {/* Only show fields that haven't been completed */}
        {!completedFields.status && (
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              color: 'gold',
              fontSize: '16px',
              fontWeight: 'bold',
              marginBottom: '5px',
              display: 'block'
            }}>
              Status <span style={{ color: 'rgba(255, 255, 255, 0.5)', fontWeight: 'normal' }}>({statusChars} characters left)</span>
            </label>
            <input
              type="text"
              name="status"
              value={profile.status}
              onChange={handleProfileChange}
              placeholder="Shown beside your username"
              maxLength={15}
              style={inputStyle}
            />
          </div>
        )}

        {/* Only show social media section if any social fields are incomplete */}
        {(!completedFields.youtube || !completedFields.tiktok || !completedFields.instagram || !completedFields.twitter) && (
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              color: 'gold',
              fontSize: '16px',
              fontWeight: 'bold',
              marginBottom: '5px',
              display: 'block'
            }}>
              Social Media Links
            </label>

            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '15px',
              marginBottom: '5px'
            }}>
              {!completedFields.youtube && (
                <div style={{ position: 'relative' }}>
                  <i className="fa-brands fa-youtube" style={{
                    position: 'absolute',
                    left: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: error.youtube ? '#ff0000' : 'rgba(255, 255, 255, 0.6)',
                    zIndex: 1,
                    fontSize: '18px'
                  }}></i>
                  <input
                    type="text"
                    name="youtube"
                    value={links.youtube.value}
                    onChange={handleLinkChange}
                    placeholder={links.youtube.name}
                    style={{
                      ...inputStyle2,
                      paddingLeft: '35px',
                      marginBottom: '0',
                      border: error.youtube ? '2px solid #ff0000' : '2px solid rgba(255, 215, 0, 0.5)'
                    }}
                  />
                  {error.youtube && (
                    <div style={{
                      position: 'absolute',
                      left: '0',
                      bottom: '-18px',
                      color: '#ff0000',
                      fontSize: '12px',
                      width: '100%',
                      textAlign: 'left',
                      paddingLeft: '5px'
                    }}>
                      {error.youtube}
                    </div>
                  )}
                </div>
              )}

              {!completedFields.tiktok && (
                <div style={{ position: 'relative' }}>
                  <i className="fa-brands fa-tiktok" style={{
                    position: 'absolute',
                    left: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: error.tiktok ? '#ff0000' : 'rgba(255, 255, 255, 0.6)',
                    zIndex: 1,
                    fontSize: '18px'
                  }}></i>
                  <input
                    type="text"
                    name="tiktok"
                    value={links.tiktok.value}
                    onChange={handleLinkChange}
                    placeholder={links.tiktok.name}
                    style={{
                      ...inputStyle2,
                      paddingLeft: '35px',
                      marginBottom: '0',
                      border: error.tiktok ? '2px solid #ff0000' : '2px solid rgba(255, 215, 0, 0.5)'
                    }}
                  />
                  {error.tiktok && (
                    <div style={{
                      position: 'absolute',
                      left: '0',
                      bottom: '-18px',
                      color: '#ff0000',
                      fontSize: '12px',
                      width: '100%',
                      textAlign: 'left',
                      paddingLeft: '5px'
                    }}>
                      {error.tiktok}
                    </div>
                  )}
                </div>
              )}

              {!completedFields.instagram && (
                <div style={{ position: 'relative' }}>
                  <i className="fa-brands fa-instagram" style={{
                    position: 'absolute',
                    left: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: error.instagram ? '#ff0000' : 'rgba(255, 255, 255, 0.6)',
                    zIndex: 1,
                    fontSize: '18px'
                  }}></i>
                  <input
                    type="text"
                    name="instagram"
                    value={links.instagram.value}
                    onChange={handleLinkChange}
                    placeholder={links.instagram.name}
                    style={{
                      ...inputStyle2,
                      paddingLeft: '35px',
                      marginBottom: '0',
                      border: error.instagram ? '2px solid #ff0000' : '2px solid rgba(255, 215, 0, 0.5)'
                    }}
                  />
                  {error.instagram && (
                    <div style={{
                      position: 'absolute',
                      left: '0',
                      bottom: '-18px',
                      color: '#ff0000',
                      fontSize: '12px',
                      width: '100%',
                      textAlign: 'left',
                      paddingLeft: '5px'
                    }}>
                      {error.instagram}
                    </div>
                  )}
                </div>
              )}

              {!completedFields.twitter && (
                <div style={{ position: 'relative' }}>
                  <i className="fa-brands fa-x-twitter" style={{
                    position: 'absolute',
                    left: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: error.twitter ? '#ff0000' : 'rgba(255, 255, 255, 0.6)',
                    zIndex: 1,
                    fontSize: '18px'
                  }}></i>
                  <input
                    type="text"
                    name="twitter"
                    value={links.twitter.value}
                    onChange={handleLinkChange}
                    placeholder={links.twitter.name}
                    style={{
                      ...inputStyle2,
                      paddingLeft: '35px',
                      marginBottom: '0',
                      border: error.twitter ? '2px solid #ff0000' : '2px solid rgba(255, 215, 0, 0.5)'
                    }}
                  />
                  {error.twitter && (
                    <div style={{
                      position: 'absolute',
                      left: '0',
                      bottom: '-18px',
                      color: '#ff0000',
                      fontSize: '12px',
                      width: '100%',
                      textAlign: 'left',
                      paddingLeft: '5px'
                    }}>
                      {error.twitter}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        {!completedFields.bio && (
          <div style={{ marginBottom: '200px' }}>
            <label style={{
              color: 'gold',
              fontSize: '16px',
              fontWeight: 'bold',
              marginBottom: '0px',
              display: 'block'
            }}>
              Bio
            </label>
            <textarea
              name="bio"
              value={profile.bio}
              onChange={handleProfileChange}
              placeholder="Tell the world about yourself and your chess journey"
              style={{
                ...inputStyle,
                height: '60px',
                resize: 'vertical'
              }}
            />
          </div>
        )}

        {/* Only show buttons if there are incomplete fields */}
        {Object.values(completedFields).some(field => !field) && (
          <div style={{ marginTop: '0px', position: 'absolute', bottom: '0', left: '50%', width: '100%', transform: 'translateX(-50%)', alignItems: 'center',
            padding: '20px 30px 15px',
            borderTop: '1px solid rgba(255, 215, 0, 0.3)',
            backgroundColor: 'rgba(20, 20, 20)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000
          }}>
            <button
              onClick={handleSaveProfile}
              id="saveChangesBtn"
              style={{
                ...buttonBaseStyle,
                ...buttonStyles.green,
                width: '80%',
                padding: '18px',
                marginBottom: '20px'
              }}
            >
              Save Profile
            </button>

            <button
              onClick={() => {
                if (hasUnsavedChanges) {
                  // Store the skip action to execute after confirmation
                  setPendingAction(() => () => {
                    if (dontShowAgain) {
                      updatePopupStage();
                    }
                    setModalOpen(false);
                    if (onClose) onClose();
                  });
                  // Show confirmation modal
                  setShowConfirmModal(true);
                } else {
                  // No unsaved changes, proceed normally
                  handleClose();
                }
              }}
              style={{
                ...buttonBaseStyle,
                ...buttonStyles.pink,
                width: '80%',
                padding: '12px',
                fontSize: '18px',
                marginBottom: '10px'
              }}
            >
              Skip For Now
            </button>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '10px'
            }}>
              <input
                type="checkbox"
                id="dontShowAgain"
                checked={dontShowAgain}
                onChange={(e) => setDontShowAgain(e.target.checked)}
                style={{ marginRight: '10px', transform: 'scale(1.2)' }}
              />
              <label
                htmlFor="dontShowAgain"
                style={{
                  color: 'rgba(255, 255, 255, 0.8)',
                  fontSize: '16px',
                  cursor: 'pointer'
                }}
              >
                Don't show this popup again
              </label>
            </div>
          </div>
        )}

       
      </div>
    </>
  );

  // Handle profile picture upload completion
  const handleProfilePictureUpload = (newPendingPhotoUrl) => {
    setPendingPhotoUrl(newPendingPhotoUrl);
    if (!hasUnsavedChanges) {
      
      setHasUnsavedChanges(true);
    }
  };

  // Look for a useEffect that uses getUserData or fetchUserData and add the photoUrl and pendingPhotoUrl updates
  useEffect(() => {
    if (user && user.credentials) {
      // Existing code populating user data
      const userData = user.credentials;
      
      // Add these lines:
      setPhotoUrl(userData.photoUrl || '');
      setPendingPhotoUrl(userData.pendingPhotoUrl || '');
      
      // Other existing code...
    }
  }, [user]);

  return (
    <>
      {/* Success Popup */}
      {showSuccessPopup && (
        <div style={{
          position: 'fixed',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
          padding: '20px 30px',
          borderRadius: '10px',
          boxShadow: '0 0 20px rgba(255, 215, 0, 0.3)',
          border: '2px solid rgba(255, 215, 0, 0.5)',
          color: 'white',
          zIndex: 10001, // Higher than other modals
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          animation: 'fadeIn 0.3s ease-out'
        }}>
          <i className="fa-solid fa-check-circle" style={{
            color: '#58b047',
            fontSize: '24px'
          }}></i>
          <span style={{
            fontSize: '16px',
            fontWeight: 'bold'
          }}>
            Profile changes sent for review!
          </span>
        </div>
      )}

      {/* Add animation styles */}
      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translate(-50%, -20px);
            }
            to {
              opacity: 1;
              transform: translate(-50%, 0);
            }
          }
        `}
      </style>

      {/* Unsaved Changes Confirmation Modal */}
      {showConfirmModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 10000 // Higher than the main modal
        }}>
          <div style={{
            backgroundColor: '#121220',
            borderRadius: '10px',
            padding: '30px',
            maxWidth: '500px',
            width: '90%',
            boxShadow: '0 0 30px rgba(255, 215, 0, 0.3)',
            border: '2px solid rgba(255, 215, 0, 0.5)',
          }}>
            <h2 style={{
              color: 'gold',
              fontSize: '24px',
              marginBottom: '20px',
              textAlign: 'center'
            }}>
              <i className="fa-solid fa-triangle-exclamation" style={{ marginRight: '10px' }}></i>
              Unsaved Changes
            </h2>

            <p style={{
              color: 'white',
              fontSize: '16px',
              lineHeight: '1.5',
              marginBottom: '25px',
              textAlign: 'center'
            }}>
              You have unsaved changes to your profile. Would you like to save them before leaving?
            </p>

            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: '15px',
              marginBottom: '15px' // Add margin to separate the button rows,
            }}>
              <button
                onClick={handleDiscardChanges}
                id="discardChangesBtn"
                style={{
                  padding: '12px 20px',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  color: 'white',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  borderRadius: '5px',
                  fontWeight: 'bold',
                  fontSize: '16px',
                  cursor: 'pointer',
                  flex: 1,
                  transition: 'all 0.3s ease'
                }}
              >
                Don't Save
              </button>
              <button
                onClick={handleSaveProfile}
                id="saveChangesBtn"
                style={{
                  padding: '12px 20px',
                  backgroundColor: '#ff0050',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  fontWeight: 'bold',
                  fontSize: '16px',
                  cursor: 'pointer',
                  flex: 1,
                  transition: 'all 0.3s ease'
                }}
              >
                Save Changes
              </button>

              
            </div>
            
            <button
              onClick={() => setShowConfirmModal(false)}
              style={{
                padding: '14px 20px',
                backgroundColor: 'rgba(255, 215, 0, 0.15)',
                color: '#ffd700',
                border: '2px solid rgba(255, 215, 0, 0.6)',
                borderRadius: '5px',
                fontWeight: 'bold',
                fontSize: '16px',
                cursor: 'pointer',
                width: '100%',
                transition: 'all 0.3s ease',
                display: 'block',
              }}
            >
              <i className="fa-solid fa-pencil" style={{ marginRight: '8px' }}></i>
              Continue Editing
            </button>
          </div>
        </div>
      )}

      <Modal
        open={modalOpen}
        onClose={hasUnsavedChanges && popupStage === 2 ? () => setShowConfirmModal(true) : handleClose}
        closeAfterTransition
        disableEscapeKeyDown={hasUnsavedChanges && popupStage === 2} // Prevent closing with Escape key when there are unsaved changes
        BackdropProps={{
          onClick: (e) => {
            // Detect clicks on the backdrop (outside modal)
            if (hasUnsavedChanges && popupStage === 2) {
              // If we have unsaved changes and on profile tab, show confirmation instead
              e.stopPropagation(); // Prevent default closing behavior
              
              
              // Set the pending action to close the modal
              setPendingAction(() => () => {
                if (dontShowAgain) {
                  updatePopupStage();
                }
                setModalOpen(false);
                if (onClose) onClose();
              });
              
              setShowConfirmModal(true);
            }
          }
        }}
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '670px',
          height: '670px',
          backgroundColor: '#000000',
          border: '3px solid #FFD700',
          borderRadius: '15px',
          boxShadow: '0 0 20px rgba(255, 215, 0, 0.2)',
          padding: '0',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          scrollbarWidth: 'thin',
          scrollbarColor: '#FFD700 transparent'
        }}>
          {/* Render tab based on popup stage */}
          {popupStage === 1 ? renderWelcomeTab() : renderProfileSetupTab()}
        </Box>
      </Modal>

      {/* FAQ Modal */}
      {showFAQModal && <FAQAndSettingsModal onClose={() => setShowFAQModal(false)} />}
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.user
});

export default connect(mapStateToProps, { getUserData })(WelcomeLoginModal); 